import Component from '../core/Component'
import Scroll from '../services/Scroll'
import PositionObserver from '../meta/PositionObserver'
import Transitions from '../utils/Fx'

export default class ProjectImage extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            image: null
        }

        this.start = null
        this.isAnimating = false
    }

    prepare() {
        this.observer = new PositionObserver(this.ref.image, {
            onRender: this.handleRender,
            onEnter: this.handleEnter,
            onLeave: this.handleLeave
        })
    }

    handleEnter = () => {
        this.isAnimating = true
    }

    handleLeave = () => {
        this.isAnimating = false
    }

    handleRender = data => {
        if (!this.start) {
            this.start = {...data}
        }

        this.render(data)
    }

    render(data) {
        // interpolate to 0-1
        const progress = (Math.abs(this.start.ratio) + data.ratio)/(Math.abs(this.start.ratio) + 1)

        const scale = 1 + 0.05 * (1 - Transitions.Quad.easeOut(progress)) // scale from 1.05 to 1
        const translateY = -50 + 15 * Transitions.Quad.easeIn(progress) // transform from -50% to -35%

        this.ref.image.style.transform = `translate(-50%, ${translateY}%) scale(${scale})`

    }

}